module.exports = __webpack_public_path__ + "static/wav2vec-0d155303879b0257b774d5591a9ab2c3.svg";